<div class="flex flex-col w-full px-6 pb-6">
  <!--    <div class="flex flex-row w-full h-12 px-4 items-center ring-1 ring-gray-100 rounded-sm shadow-sm bg-gray-50">-->
  <!--        <span class="text-hint">{{checkBox.placeholder}}</span>-->
  <!--    </div>-->
  <span class="mt-1 text-md text-hint">{{ field.description }}</span>
</div>
